import '@/utils/shared.js'; // Führt shared.js aus und hängt KuchaCommons an window

const { createMap, parsePathData, parseSvgSelector, buildWallCanvas } = window.KuchaCommons || {};

export {
  createMap,
  parsePathData,
  parseSvgSelector,
  buildWallCanvas
};